import React 		from 'react';
import ReactDOM from 'react-dom';
import Highlight 		from 'react-highlight';

import BLComponent from '../core/_BLComponent.jsx';

export default class CreateInventories extends BLComponent {
	constructor(props, context) {
		super(props, context);

		this.state = {
			
		};
	}

	render() {
		return (
			<section>
				<h1>Create Store Inventories</h1>
				<p>Creates multiple inventories in a single request. Note that you can create an inventory only with items in the BL Catalog.</p>
				<h4>Request</h4>
				<table>
					<tbody>
						<tr>
							<th>Method </th>
							<th>URI </th>
						</tr>
						<tr>
							<td> POST </td>
							<td> /inventories/</td>
						</tr>
					</tbody>
				</table>
				<h4>Parameters</h4>
				<p>Do not supply a request parameter with this method.</p>
				<h4>Request body</h4>
				<p>In the request body, supply a <a href="?page=resource-representations-inventory">store inventory resource</a>. The store inventory resource should includes:</p>
				<ul>
					<li>item.no</li>
					<li>item.type</li>
					<li>color_id</li>
					<li>quantity</li>
					<li>unit_price</li>
					<li>new_or_used</li>
					<li>completeness (only when item.type is "set")</li>
					<li>description</li>
					<li>remarks</li>
					<li>bulk</li>
					<li>is_retain</li>
					<li>is_stock_room</li>
					<li>stock_room_id (only when is_sock_room is "true")</li>
					<li>my_cost</li>
					<li>sale_rate</li>
					<li>tier_quantity1</li>
					<li>tier_price1</li>
					<li>tier_quantity2</li>
					<li>tier_price2</li>
					<li>tier_quantity3</li>
					<li>tier_price3</li>
				</ul>
				<p>Note that to set tier price options, all 6 values must be entered</p>
				<h4>Response</h4>
				<p>If successful, this method returns an empty "data".</p>
				<h4>Example</h4>
				<ul>
					<li>
						POST /inventories
						<ul>
							<li>Creates new inventories</li>
						</ul>
					</li>
				</ul>
			</section>
		);
	}
}